export var createDisplayName = function (item) {
    var _a, _b, _c, _d;
    var dpName = (item === null || item === void 0 ? void 0 : item.dpName) || (item === null || item === void 0 ? void 0 : item.dpNm);
    if ((item === null || item === void 0 ? void 0 : item.dpInsTyp) == "OPT" /* exchangeList.OPTION */ || ((_a = item === null || item === void 0 ? void 0 : item.asTyp) === null || _a === void 0 ? void 0 : _a.includes("OPT"))) {
        return (dpName +
            " " +
            ((_b = item === null || item === void 0 ? void 0 : item.dpExpDt) === null || _b === void 0 ? void 0 : _b.split("'")[0]) +
            " " +
            (item === null || item === void 0 ? void 0 : item.opTyp) +
            " " +
            (item === null || item === void 0 ? void 0 : item.stkPrc));
    }
    else if ((item === null || item === void 0 ? void 0 : item.dpInsTyp) == "FUT" /* exchangeList.FUTURE */ ||
        ((_c = item === null || item === void 0 ? void 0 : item.asTyp) === null || _c === void 0 ? void 0 : _c.includes("FUT")))
        return dpName + " " + ((_d = item === null || item === void 0 ? void 0 : item.dpExpDt) === null || _d === void 0 ? void 0 : _d.split("'")[0]) + " " + (item === null || item === void 0 ? void 0 : item.dpInsTyp);
    else
        return dpName;
};
export var findInstrument = function (symList, returnExchange) {
    var symDetail = symList.filter(function (symDet) { return symDet.exc == "NFO" /* excList.NFO */ || symDet.exc == "BFO" /* excList.BFO */; });
    if (returnExchange && symDetail && symDetail[0])
        return symDetail[0].exc;
    else if (symDetail && symDetail[0])
        return symDetail[0].optExpIdx;
    else
        return "";
};
